import { useQuery, useQueryClient } from "@tanstack/react-query";

import QueryData from "Constants/QueryData";

import { useAppSelector } from "Hooks/useRedux";

import Api from "Api";

export default function useStations() {
  const queryClient = useQueryClient();

  const { status } = useAppSelector((state) => state.menu);
  const { visible } = useAppSelector((state) => state.stations);
  const { visible: trafficVisible } = useAppSelector((state) => state.trafficStations);

  const { source, destination } = useAppSelector((state) => state.zones);
  const { conformity, stations } = useAppSelector((state) => state.filters);

  const filterQueries = () => {
    let result = "";
    Object.keys(stations).forEach((i) => {
      const value = stations[i as keyof typeof stations];
      if (value !== "") result += `&${i}=${value}`;
    });
    return result;
  };
  const conformityQuery = () => {
    return `${conformity.source ? "&contain[]=sources" : ""}${conformity.destination ? "&contain[]=destinations" : ""}`;
  };
  const zonesQuery = () => {
    return `${source.length > 0 ? `&${source.map((i) => `sources[]=${i}`).join("&")}` : ""}${
      destination.length > 0 ? `&${destination.map((i) => `destinations[]=${i}`).join("&")}` : ""
    }`;
  };

  const queryKey = [QueryData.STATION.key, source, destination, conformity];

  const invalidateQuery = () => {
    queryClient.invalidateQueries({ queryKey });
  };

  const { data, isLoading, refetch, isFetching } = useQuery({
    queryKey,
    queryFn: () =>
      Api.get(`${QueryData.STATION.url}${conformityQuery()}${zonesQuery()}${filterQueries()}`).then(
        (res) => res.data.Data.stations.data
      ),
    enabled: visible || trafficVisible || status === "stations",
  });

  return { data, isLoading, refetch, isFetching, invalidateQuery };
}
